import { Box, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useLoanFlags } from '../../hooks/useLoanFlags';
import { BorrowerSummaryCard } from '../cards/borrowerSummaryCard';
import { LoanOriginatorCard } from '../cards/loanOriginatorCard';
import { LoanKeyDates } from '../cards/loanKeyDates';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { LoanDetailsCardFixFlip } from './loanDetailsCardFixFlipV2';
import { LoanDetailsCardGroundUp } from './loanDetailsCardGroundUpV2';
import { useBaseStore } from '@roc/feature-app-core';
import { useSubmissionVsUnderwritingStore } from '../../hooks/useSubmissionVsUnderwritingStore';
import { useLoanStore } from '@roc/feature-loans';
import { LoanSummaryTodosTasksCard } from '../cards/loanSummaryTodosTasksCard';
import UpdateLogCard from '../cards/updateLogCard';
import { useRouteMatch } from 'react-router';
import { NotFullySubmittedAlert } from '../cards/notFullySubmittedAlert';
import { useEffect } from 'react';
import LoanValuesChart from 'libs/feature-draws/src/draws/loanDrawsDashboard/components/loanValuesChart';
import { PaperBorderType } from '@roc/ui';

export const LoanSummaryBridgeV2 = observer(({ groundUp = false }) => {
  const useStyles = makeStyles((theme: Theme) => ({
    container: {
      marginTop: '16px',
      marginBottom: '16px',
    }
  }));
  const classes = useStyles();
  const { showOriginatorsCard, isLenderOriginator, allowLoanPricing, isTaskFrameworkEnabled } = useLoanFlags();
  const { globalStore } = useBaseStore();
  const isEstimatedClosingCostEnabled = globalStore.userFeatures.isEstimatedClosingCostEnabled;
  const { submissionVsUnderwritingStore } = useSubmissionVsUnderwritingStore();
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;
  const isAttorneyPortal = useRouteMatch('/attorney-portal');
  const showDrawsUI = loanDetails?.showDraws && !isAttorneyPortal
  const isServicerPortal = useRouteMatch('/servicer-portal');

  useEffect(() => {
    if (loanStore?.doAutoRefresh && !loanStore?.autoRefreshOn) {
      loanStore.setAutoRefreshOn(true);
      console.log('Will do auto refresh');
      setTimeout(function () {
        window.location.reload();
      }, 180000);
    }
  }, [loanStore?.doAutoRefresh]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <LoanKeyDates />
        </Grid>
        <Grid item xs={12}>
          {groundUp ? <LoanDetailsCardGroundUp /> : <LoanDetailsCardFixFlip />}
        </Grid>
        <Grid item xs={12}>
          {loanDetails?.fullySubmitted ?
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <LoanSummaryTodosTasksCard />
              </Grid>
              <Grid item xs={12} md={4}>
                <Box display={'flex'} flexDirection={'column'}>
                  {showDrawsUI &&
                    <Box flexGrow={1} pb={2}>
                      <Grid item xs={12} >
                        <LoanValuesChart
                          chRemaining={
                            loanStore?.loanDetails?.calculatedLoanData?.constructionHoldbackRemaining
                              ? loanStore?.loanDetails?.calculatedLoanData?.constructionHoldbackRemaining
                              : 0
                          }
                          chReimbursedToDate={
                            loanStore?.loanDetails?.calculatedLoanData?.constructionHoldbackFunded
                              ? loanStore?.loanDetails?.calculatedLoanData?.constructionHoldbackFunded
                              : 0
                          }
                          borderType={PaperBorderType.SOLID_BORDER}
                        />
                      </Grid>
                    </Box>
                  }
                  {!isServicerPortal && !isLenderOriginator && <Box flexGrow={1} pt={showDrawsUI ? 2 : 0} style={{ marginBottom: 20 }}>
                    <LoanOriginatorCard readOnly={!allowLoanPricing} />
                  </Box>}
                  <Box flexGrow={1} pt={showOriginatorsCard ? 2 : 0}>
                    <BorrowerSummaryCard />
                  </Box>
                  {/* {isTaskFrameworkEnabled && allowLoanPricing && <Box pt={2} flexGrow={1}>
                  <UpdateLogCard loanId={loanDetails.loanId}/>
                </Box>} */}
                </Box>
              </Grid>
            </Grid>
            :
            <Grid container spacing={2}>
              <NotFullySubmittedAlert />
            </Grid>
          }
        </Grid>
      </Grid>
    </>
  );
});
